// extracted by mini-css-extract-plugin
export default {"link":"h_qmZuKBrM7SWOEcmH68","isPrimary":"iZ_WxIDQyqM2SOYqu4Y8"};